export {default} from './Messages';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/Messages/index.ts